// import node module libraries
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Container } from 'react-bootstrap';
import axios from 'axios';

// Import authentication components
import useAuthHeader from 'react-auth-kit/hooks/useAuthHeader';

// Import Loading Animation
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

//import translation hook
import { useTranslation } from 'react-i18next';

// import data files
//import FAQsData from 'data/marketing/compare-plans/FAQsData';

const FAQs = () => {
	const { t } = useTranslation(); // useTranslation-Hook
	const [FAQList, setFAQList] = useState([]);
	const [isLoading, setIsLoading] = useState(true);

	const authHeader = useAuthHeader();
	// fetch data from api
	const options = {
		params: {

		},
		headers: {
			Authorization: authHeader,
			Accept: 'application/json'
		}
	};

	const getData = async () => {
		setIsLoading(true);

		// Dynamische URL basierend auf der Umgebung
		const baseURL = process.env.REACT_APP_ENV === 'development'
			? `http://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`
			: `https://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`;

		await axios.get(`${baseURL}/public/faqs?faq_categories=general&limit=8`, options)
			.then(response => {
				const responseData = response.data.data; // Extract the data from the response
				setFAQList(
					responseData
						? responseData.map(item => ({
							id: item.id,
							title: item.faq_title,
							content: item.faq_content
						}))
						: []
				); // Map the data to match the expected keys
				setIsLoading(false);
			})
			.catch((error) => {
				setIsLoading(false);
			});
	}

	useEffect(() => {
		getData();
	}, []);

	return (
		<section className="pb-14 pt-lg-8 bg-white">
			<Container>
				<Row>
					<Col xl={6} lg={10} xs={12}>
						<div className="mb-8 pe-8">
							{/* heading */}
							<h1 className="display-4 fw-bold mb-4">
								{t('Frequently asked questions')},
								<span className="text-primary"> {t('answered')}.</span>
							</h1>
							{/* para */}
							<p className="fs-4">
								{t('You have additional questions?')} <Link to="/marketing/help-center/faq">{t('Visit our Help Center')}<i className="fe fe-arrow-right"></i></Link>
							</p>
						</div>
					</Col>
				</Row>
				<Row>
					{/* FAQs  */}
					{isLoading || FAQList && FAQList.length == 0 ? (
						<Skeleton height="40px" count={8} />
					) : (
						FAQList && FAQList.length > 0 && (
							FAQList.map((item, index) => (
								<Col md={6} xs={12} key={index}>
									<div className="mb-6 pe-lg-8">
										<h3 className="mb-2">{item.title}</h3>
										<p className="fs-4">{item.content}</p>
									</div>
								</Col>
							))
						)
					)}
					
				</Row>
			</Container>
		</section>
	);
};

export default FAQs;
